import * as React from "react";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { IHorizontalCardsPanelVariants, ITextCard } from "../../../types/common";
import { PanelWrapper } from "../../PanelWrapper";
import { HorizontalCardsPanelV1 } from "./v1";
import { HorizontalCardsPanelV2 } from "./v2";

import "./v2/style.scss";

export interface IHorizontalCardsPanelProps {
  title: IContentfulRichTextResponse;
  subtitle?: string;
  isBetterV2?: boolean;
  cards: ITextCard[];
  variant?: IHorizontalCardsPanelVariants;
}

export const HorizontalCardsPanel: React.FC<IHorizontalCardsPanelProps> = ({
  isBetterV2,
  title,
  subtitle,
  cards,
  variant = IHorizontalCardsPanelVariants.HORIZONTAL,
}) => (
  <PanelWrapper
    isBetterV2={isBetterV2}
    backgroundColour={isBetterV2 ? variant : undefined}
    className={isBetterV2 ? "panel-wrapper__horizontal-panel" : undefined}
  >
    {isBetterV2 ? (
      <HorizontalCardsPanelV2 title={title} subtitle={subtitle} variant={variant} cards={cards} />
    ) : (
      <HorizontalCardsPanelV1 title={title} variant={variant} cards={cards} />
    )}

  </PanelWrapper>
);
